import React from "react";
import { useNavigate } from "react-router-dom";
import {  useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./noResults.css";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";

const NoFoldersResults = (props) => {
  const { isPermissionCreateFolders } = props;
  const navigate = useNavigate();
  const main = useSelector(state => state.main);
  return (
    <div className="Folders-noResults-root">
      {main.myType === "STUDIO" && isPermissionCreateFolders ?
        <div>
          <div className="iconStudio"><FontAwesomeIcon icon={["far", "folder"]} /></div>
          <div className="textStudio"><FormattedMessage id="folders.noFolders1" defaultMessage={"Crea un set di documenti da rendere disponibili ai tuoi clienti."} /></div>
          <div className="buttonStudio"><Button onClick={() => navigate("/folders-edit")} size='small' kind='secondary'><FormattedMessage id="folders.noFolders2" defaultMessage={"Crea il tuo primo fascicolo"} /></Button></div>
        </div>
        :
        <div>
          <div className="iconCompany"><FontAwesomeIcon icon={["far", "folder"]} /></div>
          <div className="textCompany"><FormattedMessage id="folders.noFolders3" defaultMessage={"Non hai ancora fascicoli disponibili."} /></div>
        </div>
      }
    </div>
  );
};

export default NoFoldersResults;